// extracted by mini-css-extract-plugin
export default {"InputBox":"InputBox_InputBox__iBMBS","TextFieldWrapper":"InputBox_TextFieldWrapper__M5QNO"};